var React = require('react');

function AnimatedChevron (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("line",{"x1":"10","y1":"50","x2":"50","y2":"50","transform":"rotate(32 0 0) translate(18 -35)","key":0}),React.createElement("line",{"x1":"90","y1":"50","x2":"50","y2":"50","transform":"rotate(-32 0 0) translate(-35 18)","key":1})]));
}

AnimatedChevron.defaultProps = {"focusable":"false","width":"100","height":"100","viewBox":"0 0 100 100","preserveAspectRatio":"xMidYMid"};

module.exports = AnimatedChevron;

AnimatedChevron.default = AnimatedChevron;
